import styled from "styled-components"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h3`
  ${mobileTextStyles.MobileHeadingThreeBold}
  color: var(--body-text-grey);
  margin-top: 24px;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingFourRegular}
    color: var(--slate);
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingFourBold}
  }
`

export const Description = styled.p`
  ${mobileTextStyles.MobileBodyRegular}
  margin-top: 16px;
  color: var(--body-text-grey);
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletBodyRegular}
    color: var(--slate);
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    margin-top: 20px;
  }
`
